import useStripeConnect from '@hooks/useStripeConnect';
import { Typography } from '@mui/material';
import { ConnectComponentsProvider, ConnectNotificationBanner } from '@stripe/react-connect-js';

interface Props {
    connectedAccountId: string | undefined;
}

// NOTE: this component is used in the EventProvider for the event's required info,
// not hooked up the logged in user, but you could easily pull that stripe id from the StripeAccountProvider
export function StripeRequiredInfo({ connectedAccountId }: Props) {
    const stripeConnectInstance = useStripeConnect(connectedAccountId);

    if (!connectedAccountId || !stripeConnectInstance) {
        return <Typography>Stipe account loading or not connected successfully</Typography>;
    }

    return (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <ConnectNotificationBanner
                collectionOptions={{
                    fields: 'eventually_due',
                    futureRequirements: 'include',
                }}
            />
        </ConnectComponentsProvider>
    );
}
